import React from "react";
import {GridCell, GridContainer} from "../Grid";
import {HelpText} from "./HelpText";
import {helpTextSuffix} from "./inputConstants";

interface InputFormProps {
    children: React.ReactNode;
    hasMarginX?: boolean;
    hasMarginY?: boolean;
    hasPaddingX?: boolean;
    hasPaddingY?: boolean;
    helpHtml?: string;
    name: string;
}

export const InputForm: React.FC<InputFormProps> = ({
                              children,
                              hasMarginX = true,
                              hasMarginY,
                              hasPaddingX,
                              hasPaddingY,
                              helpHtml,
                              name
                          }: InputFormProps) => {
    const handleSubmit = (event: React.FormEvent) => event.preventDefault();

    return (
        <form aria-describedby={`${name}${helpTextSuffix}`} onSubmit={handleSubmit}>
            <GridContainer hasMarginX={hasMarginX} hasMarginY={hasMarginY} hasPaddingX={hasPaddingX} hasPaddingY={hasPaddingY}>
                {children}
                <GridCell>
                    <HelpText name={name} helpText={helpHtml}/>
                </GridCell>
            </GridContainer>
        </form>

    );
};
